export class DadosGravaModel {
    
	public numInscricao: string; 				//p007_NuInscricao;
	public razaoSocial: string;						//p007_RazaoSocial;
	public email: string;							//p007_Email;
	public situacaoEmpresa: number;					//p007_SituacaoEmpresa;
	public numPerfil: number;						//p001_NumeroPerfil;
	public coCertificado: string;					//p001_CO_Certificado;
	public autoridadeCertificadora: string;			//p001_AutoridadeCertificadora;
	public coSerial: string;						//p001_CO_serial;
	public DataEmissao: string;						//p001_DataEmissao;
	public DataValidade: string;						//p001_DataValidade;
	public chavePublica: string;					//p001_ChavePublica;
	public certificado: string;						//p001_Certificado;
	public numCpf: number;						//p001_NumeroCPF;
	public nomeResponsavel: string;					//p001_NomeResponsavel;
	public numPis: number;							//p001_NumeroPIS;
	public numRg: string;							//p001_RG;
	public orgaoExpedidor: string;					//p001_OrgaoExpedidor;
	public codigoUf: string;						//p001_CodigoUF;
	public nomeComum: string;						//p001_NomeComum;
	public caepfDv: number;						//p001_CAEPF_DV;
	public caepf: number;								//p001_CAEPF;
	public tipoContrato: number;					//p003_TipoContrato;
	public ultimoTipoChancela: number;				//p003_UltimoTipoChancela;
	public dataUltimaChancela: string;			//p003_DataUltimaChancela;
	public tipoChancela: number;					//p002_TipoChancela;
	public dataChancela: string;					//p002_DataChancela;
	public imagemChancela: string;					//p002_ImagemChancela;
	public imagemAssinatura: string;				//p002_ImagemAssinatura;
	public imagemAssinaturaSistema: string;			//p002_ImagemAssinaturaSistema;
	public cpfResponsavel: number;				//p002_CPFResponsavel;

	public  servicos: string[];
}